var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visited)?_c('div',[_vm._m(0),_c('div',{staticClass:"dialog-bj",staticStyle:{"display":"block"}})]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"outer"}),_c('div',{staticClass:"middle"}),_c('div',{staticClass:"inner"})])
}]

export { render, staticRenderFns }